import { store } from '@/common/root';
import { useL18nAdapterSync } from '@/common/composables/useL18nAdapterSync';
import { setupOagwWebSocketRecovery } from '@/common/utils/setupOagwWebSocketRecovery';
import type { useAuthStore } from '@/common/store/pinia/auth';
import type { usePermissionsStore } from '@/common/store/pinia/permissions';
import type { ModePreset } from '@/common/store/pinia/appMode';

export async function initFederatedApp({
  providers,
  authStore,
  permissionsStore,
  setAppModeSettings
}: {
  providers?: AppOptions['providers'],
  authStore: ReturnType<typeof useAuthStore>,
  permissionsStore: ReturnType<typeof usePermissionsStore>,
  setAppModeSettings: (settings: DeepPartial<ModePreset>) => void
}) {
  setupOagwWebSocketRecovery({
    oagwHeaders: providers?.oagwHeaders,
    setAppModeSettings
  });
  useL18nAdapterSync(providers?.l18nAdapter);
  await authStore.initAuthConfig();
  await permissionsStore.fetchAuthMeta();
  await store.dispatch('socket/CONNECT');
}
